import { Outlet, useNavigate } from "react-router-dom";
import Navbar from "../components/navbar";
import NotificationBanner from "../components/NotificationBanner";

export default function Layout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Example: Clear token or user data from localStorage/session
    localStorage.removeItem("authToken");
    
    // Redirect to login page
    navigate("/login");
    localStorage.setItem("isLoggedIn", "false");
  };

  return (
    <div
      style={{
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "repeat",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--color-bg)",
      }}
    >
      <NotificationBanner 
        message="Velkommen tilbake! Vi har nå lagt inn informasjon om toastmaster og oppdatert litt prakitsk info."
        type="info"
        dismissible={true}
      />
      <Navbar />
      <main>
        <Outlet />
      </main>
    </div>
  );
}